import { FormLayout, Button, ButtonGroup, InlineStack } from '@shopify/polaris';
import { FormEvent, ReactNode } from 'react';

export interface ResourceFormProps {
  children: ReactNode;
  submitLabel?: string;
  cancelLabel?: string;
  onSubmit: () => void;
  onCancel?: () => void;
  submitting?: boolean;
  disabled?: boolean;
}

export function ResourceForm({
  children,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  onSubmit,
  onCancel,
  submitting,
  disabled,
}: ResourceFormProps): JSX.Element {
  function handleSubmit(e: FormEvent<HTMLFormElement>): void {
    e.preventDefault();
    onSubmit();
  }
  return (
    <form onSubmit={handleSubmit}>
      <FormLayout>
        {children}
        <InlineStack align="end">
          <ButtonGroup>
            {onCancel ? (
              <Button onClick={onCancel} disabled={submitting}>
                {cancelLabel}
              </Button>
            ) : null}
            <Button submit variant="primary" loading={submitting} disabled={disabled}>
              {submitLabel}
            </Button>
          </ButtonGroup>
        </InlineStack>
      </FormLayout>
    </form>
  );
}
